import { Component } from 'react';

class Service extends Component {

  async universalpostServiceCall(url, params) {
    if (navigator.onLine) {
      if ((typeof params).toLowerCase() == "string") {
        params = JSON.parse(params);
      }
      if (!params.hasOwnProperty('IsTryingToConceive')) {
        params['IsTryingToConceive'] = global.userAry['IsTryingToConceive'];
      }

      const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
          'Content-Type': 'application/json',
          'ftk': global.ftk,
          'uid': global.uID,
          'access-token': global.accessToken,
          'user-agent': global.userAgent,
          'isdesktop': global.isdesktop
        }
      });
      const resp = await response.json();
      return resp;
    } else {
      this.hideLoader();
      this.showAlert("Please Check Internet Connection!!!");
      return false;
    }
  }

  // postServiceCall(url, params) {
  //   if (navigator.onLine) {
  //     if ((typeof params).toLowerCase() == "string") {
  //       params = JSON.parse(params);
  //     }
  //     if (!params.hasOwnProperty('IsTryingToConceive')) {
  //       params['IsTryingToConceive'] = global.userAry['IsTryingToConceive'];
  //     }
  //     return fetch(url, {
  //       method: 'POST',
  //       body: JSON.stringify(params),
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'ftk': (global.ftk) ? global.ftk : '',
  //         'uid': global.uID,
  //         'access-token': global.accessToken,
  //         'user-agent': global.userAgent,
  //         'isdesktop': global.isdesktop
  //       }
  //     }).then(res => res.json());
  //   } else {
  //     this.hideLoader();
  //     this.showAlert("Please Check Internet Connection!!!");
  //     return false;
  //   }
  // }
  postServiceCall(url, params) {
    if (navigator.onLine) {
      try {
        // Log the initial parameters
        console.log("Initial Params:", params);
        console.log("typeof params:", typeof params);

        if ((typeof params).toLowerCase() == "string") {
          params = JSON.parse(params);
          // Log the parsed params
          console.log("Parsed Params:", params);
        }

        if (!params.hasOwnProperty('IsTryingToConceive')) {
          params['IsTryingToConceive'] = global.userAry['IsTryingToConceive'];
          // Log the params after adding IsTryingToConceive
          //console.log("Params with IsTryingToConceive:", params);
        }

        // Log the URL and final parameters before the fetch call
        console.log("URL:", url);
        console.log("window.__AUTH_DATA__.ftk in client old:", window.__AUTH_DATA__.ftk);
        console.log("Final Params:", params);
        console.log("global.ftk in client new:", window.__AUTH_DATA__.ftk);
        console.log("global.uID in client:", global.uID);
        console.log("global.accessToken in client:", global.accessToken);
        console.log("global.userAgent in client:", global.userAgent);
        console.log("global.isdesktop in client:", global.isdesktop);
        console.log("global.userAry in client:", global.userAry);
        return fetch(url, {
          method: 'POST',
          body: JSON.stringify(params),
          headers: {
            'Content-Type': 'application/json',
            'ftk': global.ftk ? global.ftk : '',
            'uid': global.uID,
            'access-token': global.accessToken,
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
          }
        })
          .then(res => res.json())
          .then(data => {
            // Log the response data
            console.log("Response Data:", data);
            return data;
          })
          .catch(error => {
            // Log any errors from the fetch call
            console.error("Fetch Error::", error);
            throw error;
          });
      } catch (error) {
        // Log any errors from the parsing or other operations
        console.error("Error in postServiceCall:", error);
        throw error;
      }
    } else {
      this.hideLoader();
      this.showAlert("Please Check Internet Connection!!!");
      return false;
    }
  }

  postServiceCall1(url, params) {
    if (navigator.onLine) {
      if ((typeof params).toLowerCase() == "string") {
        params = JSON.parse(params);
      }
      if (!params.hasOwnProperty('IsTryingToConceive')) {
        params['IsTryingToConceive'] = global.userAry['IsTryingToConceive'];
      }
      //console.log("INSIDEeeeeeeeeeeeeeee POSTSERVICE CALL::::::::::::::");
      //console.log("global.ftk:::::::::::::::", global.ftk)
      //console.log("access-token:::::::::::::::", global.accessToken)
      //console.log("user-agent:::::::::::::::", global.userAgent)
      //console.log("uid:::::::::::::::", global.uID)

      return fetch(url, {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
          'content-type': 'application/json',
        }
      }).then(res => res.json());
    } else {
      this.hideLoader();
      this.showAlert('Please Check Internet Connection!!!');
      return false;
    }
  }

  postServiceCallFC(url, params) {
    if (navigator.onLine) {
      return fetch(url, {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(res => res.json());
    } else {
      this.hideLoader();
      this.showAlert("Please Check Internet Connection!!!");
      return false;
    }
  }

  getServiceCall(url) {
    if (navigator.onLine) {
      return fetch(url).then(res => res.json());
    } else {
      this.hideLoader();
      this.showAlert("Please Check Internet Connection!!!");
      return false;
    }
  }

  // postFileServiceCall(url, file, file_name) {
  //   if (navigator.onLine) {
  //     const data = new FormData()
  //     data.append('file', file, file_name)
  //     return fetch(url, {
  //       method: 'POST',
  //       body: data,
  //       headers: {
  //         'ftk': global.ftk,
  //         'uid': global.uID,
  //         'access-token': global.accessToken,
  //         'user-agent': global.userAgent,
  //         'isdesktop': global.isdesktop
  //       }
  //     }).then(res => res.json());
  //   } else {
  //     this.hideLoader();
  //     this.showAlert("Please Check Internet Connection!!!");
  //     return false;
  //   }
  // }

  postFileServiceCall(url, file, file_name,vStart,vEnd) {
    if (navigator.onLine) {
      //console.log("file_name -----", file_name)
      const data = new FormData()
      data.append('file', file, file_name)
      data.append('vStart', vStart)
      data.append('vEnd', vEnd)
      // //console.log("data ------------------>",data)
      // //console.log("API URL in services::::::::::::::::::::::::",url)
      return fetch(url, {
        method: 'POST',
        body: data,
        headers: {
          'ftk': global.ftk,
          'uid': global.uID,
          'access-token': global.accessToken,
          'user-agent': global.userAgent
          // 'isdesktop': global.isdesktop
        }
      })
        .then(res => {
          // //console.log("Response ===='/:", res); // Add this line to log the response status
          return res.json();
        })
        .catch(error => {
          //console.log("Fetch Errorr ----->", error); // Add this line to log any fetch error
          throw error;
        });
    } else {
      this.hideLoader();
      this.showAlert("Please Check Internet Connection!!!");
      return Promise.reject("No internet connection");
    }
  }


  jsontracker(val) {
    //console.log(val);
    // var t = {
    //   appurl: val
    // };
    // //console.log("jsontrack t",t);
    if (window.MobileBridge) {
      window.MobileBridge.changeNavbarBackground(val);
      return true;
    } else if (/iphone|ipod|ipad/.test(window.navigator.userAgent.toLowerCase())) {
      // var iOSAppScheme = 'FirstcryCarnival';
      // var iOSAppAction = 'CarnivalActionType';
      // var escapedJsonParameters = encodeURI(val);
      // var url = iOSAppScheme + '://' + iOSAppAction + '#' + escapedJsonParameters;
      // url = url.replace('%20', ' ');
      // document.location.href = url;
      window.webkit.messageHandlers.cookieStatus.postMessage(val);

      return true;
    } else {
      return false;
    }
  }

  replaceSymbols(val) {
    if (val) {
      var mainurl = val.trim().toLowerCase();
      if (__isBrowser__ && window.location.href.includes('coloring-pages-printables')) {
        mainurl = mainurl.replace(/&/g, "and");
      }
      mainurl = mainurl.replace(/[\W_]+/g, "-");
      mainurl = mainurl.replace("---", "-");
      mainurl = mainurl.replace("--", "-");
      if (mainurl.charAt(0) == '-') {
        mainurl = mainurl.substr(1);
      }
      return mainurl;
    } else {
      return val;
    }
  }

  genquestionurl(question_title) {
    // //console.log("question_title ==", question_title);
    if (question_title) {
      var questiontitle = question_title.trim();

      var mainurl = questiontitle.trim().toLowerCase();
      mainurl = mainurl.replace(/[\W_]+/g, "-");
      mainurl = mainurl.replace("---", "-");
      mainurl = mainurl.replace("--", "-");
      if (mainurl.charAt(0) == '-') {
        mainurl = mainurl.substr(1);
      }
      // //console.log("hash text ====", mainurl);
      var canonicalurl = mainurl;
      var newcanonicalurl = "";
      var newstring1 = [];
      for (var t = 0; t < canonicalurl.replace(/[\u0080-\u10FFFF]/g, "x").length; t++) {
        if (canonicalurl[t] && (canonicalurl[t].match('/\s/') || canonicalurl[t].match('/\-/'))) {
          // 
        } else {
          if (canonicalurl[t] != "-") {
            newstring1.push(canonicalurl[t]);
          }
        }
        if (newstring1.length <= 100) {
          newcanonicalurl = newcanonicalurl + '' + canonicalurl[t];
        } else {
          break;
        }
      }
      newcanonicalurl = newcanonicalurl.replace('/\s+/', '-');
      newcanonicalurl = newcanonicalurl.replace('/\-+/', '-');

      var rurl = newcanonicalurl;
      rurl = rurl.replace('/\-+/', '-');

      var mainurl = rurl.trim().toLowerCase();
      mainurl = mainurl.replace(/[\W_]+/g, "-");
      mainurl = mainurl.replace("---", "-");
      mainurl = mainurl.replace("--", "-");
      if (mainurl.charAt(0) == '-') {
        mainurl = mainurl.substr(1);
      }

      return mainurl;
    } else {
      return "";
    }
  }

  showTracking() {
    if (document.getElementById('hidden_tracking')) {
      document.getElementById('hidden_tracking').style.display = "block";
    }
  }

  hideTracking() {
    if (document.getElementById('hidden_tracking')) {
      document.getElementById('hidden_tracking').style.display = "none";
    }
  }

  showLoader() {
    document.getElementsByClassName('loader-overlay')[0] && (document.getElementsByClassName('loader-overlay')[0].style.display = "block");
    // document.getElementsByTagName('body')[0].style.overflow = 'hidden';
  }
  showScrollLoader() {
    document.getElementsByClassName('scroll-loader')[0] && (document.getElementsByClassName('scroll-loader')[0].style.display = "block");
    // document.getElementsByTagName('body')[0].style.overflow = 'hidden';
  }
  hideScrollLoader() {
    // document.getElementsByTagName('body')[0].style.overflow = 'visible';
    document.getElementsByClassName('scroll-loader')[0] && (document.getElementsByClassName('scroll-loader')[0].style.display = "none");
  }

  hideLoader() {
    // document.getElementsByTagName('body')[0].style.overflow = 'visible';
    document.getElementsByClassName('loader-overlay')[0] && (document.getElementsByClassName('loader-overlay')[0].style.display = "none");
  }

  showAlert(msg) {
    document.getElementsByClassName('alertmsg')[0] && (document.getElementsByClassName('alertmsg')[0].innerHTML = msg);
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    document.getElementsByClassName('alertMsg-overlay')[0] && (document.getElementsByClassName('alertMsg-overlay')[0].style.display = "block");
    setTimeout(function () {
      document.getElementsByClassName('alertMsg-overlay')[0] && (document.getElementsByClassName('alertMsg-overlay')[0].style.display = "none");
      document.getElementsByTagName('body')[0].style.overflow = 'visible';
      document.getElementsByClassName('alertmsg')[0] && (document.getElementsByClassName('alertmsg')[0].innerHTML = "");
    }, 1000);
  }

  sticky_div() {
    if (document.getElementsByClassName('registrationRight')[0]) {
      var scrollTop = window.pageYOffset;
      var div_top = document.getElementsByClassName('registrationRight')[0].offsetTop + 164;
      var left_panle = document.getElementsByClassName('sub-container')[0].offsetHeight;
      var left_height = document.getElementsByClassName('main-container')[0].offsetHeight;
      document.getElementsByClassName('registrationRight')[0].style.height = left_panle +"px";
      var right_height = document.getElementsByClassName('rightside')[0].offsetHeight;
      var footerEle = document.getElementsByClassName('footer_fclogo_text_container')[0];
      if (this.elementInViewport2(footerEle)) {
        if (scrollTop > div_top && left_height > right_height) {
          document.getElementsByClassName('rightside')[0].classList.remove('stick');
          document.getElementsByClassName('rightside')[0].classList.add('btmfixed');
        }
      } else {
        document.getElementsByClassName('rightside')[0].classList.remove('btmfixed');
        if (scrollTop > div_top && left_height > right_height) {
          document.getElementsByClassName('rightside')[0].classList.add('stick');
        } else {
          document.getElementsByClassName('rightside')[0].classList.remove('stick');
        }
      }

    }
  }

  elementInViewport2(el) {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;
  
    while(el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }
  
    return (
      top < (window.pageYOffset + window.innerHeight) &&
      left < (window.pageXOffset + window.innerWidth) &&
      (top + height) > window.pageYOffset &&
      (left + width) > window.pageXOffset
    );
  }
  isScrolledIntoView(elem) {
    var docViewTop = window.pageYOffset;
    var docViewBottom = docViewTop + window.outerHeight;
    var elemTop = elem ? elem.offsetTop : 0;
    var elemBottom = elemTop;
    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  }

  // loadImages() {
  //   var imgDefer = document.getElementsByTagName('img');
  //   for (var i = 0; i < imgDefer.length; i++) {
  //     if (imgDefer[i].hasAttribute('data-src')) {
  //       var newsrc = imgDefer[i].getAttribute('data-src');
  //       imgDefer[i].setAttribute('src', newsrc);
  //       imgDefer[i].removeAttribute("data-src");
  //       imgDefer[i].onload = function () {
  //         this.classList.remove('loadingImg');
  //       };
  //     }
  //   }
  // }

 
  loadImages() {
  const imgDefer = document.querySelectorAll('img[data-src]');
  imgDefer.forEach(img => {
    const newSrc = img.getAttribute('data-src');
    const tempImg = new Image();
    tempImg.onload = function () {
      img.src = newSrc;
      img.classList.remove('loadingImg');
      img.removeAttribute('data-src');
    };

    tempImg.onerror = function () {
      img.classList.remove('loadingImg');
      img.classList.add('imgError');
    };
    tempImg.src = newSrc; // start preloading
  });
}




  lazyLoadImages(){
    var docElem = document.documentElement;
    window.lazySizesConfig = window.lazySizesConfig || {};
    window.lazySizesConfig.loadMode = 1;
    //set expand to a higher value on larger displays
    window.lazySizesConfig.expand = Math.max(Math.min(docElem.clientWidth, docElem.clientHeight, 1222) - 1, 359);
    window.lazySizesConfig.expFactor = lazySizesConfig.expand < 380 ? 3 : 2;
  }

  slideSlider = (id, scrollVal, scrollTime) => {
    this.scrollHorizontal(document.getElementById(id), scrollVal, scrollTime);
  }

  scrollHorizontal(element, change, duration) {
    var start = element.scrollLeft,
      currentTime = 0,
      increment = 20;

    var easeInOutQuad = (t, b, c, d) => {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    };

    var animateScroll = function () {
      currentTime += increment;
      var val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollLeft = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  }

  intToString(value) {
    if (!value) {
      return '0';
    } else if (isNaN(value) || parseInt(value) <= 999) {
      return value;
    } else {
      var suffixes = ["", "K", "M", "B", "T"];
      var suffixNum = Math.floor(("" + value).length / 3);
      var shortValue = parseFloat((suffixNum != 0 ? (value / Math.pow(1000, suffixNum)) : value).toPrecision(2));
      var shortNum = shortValue;
      if (shortValue % 1 != 0) {
        shortNum = shortValue.toFixed(1);
      }
      return shortNum + suffixes[suffixNum];
    }
  }

  secondsToMS(s) {
    let m = Math.floor(s / 60);
    s -= m * 60;
    s = Math.floor(s);
    return (m < 10 ? '0' + m : m) + ":" + (s < 10 ? '0' + s : s)
  }

  getUserActionPayload(childData, mycid) {
    let user_gender = 'NA';
    if (childData['UserMaster'] && childData['UserMaster']['Sex'] && childData['UserMaster']['Sex'] != "") {
      user_gender = childData['UserMaster']['Sex'];
    }
    let expecting_dob = '';
    if (childData['UserChildList'] && childData['UserChildList'].length > 0 && childData['UserChildList'][0]['IsExpected']) {
      expecting_dob = childData['UserChildList'][0]['DOB'];
    }
    let user_childinfo = [];
    if (childData['UserChildList']) {
      for (let c = 0; c < childData['UserChildList'].length; c++) {
        user_childinfo[c] = {};
        user_childinfo[c]['id'] = childData['UserChildList'][c]['ChildId'];
        user_childinfo[c]['gender'] = childData['UserChildList'][c]['Gender'];
        user_childinfo[c]['childdob'] = childData['UserChildList'][c]['DOB'];
        user_childinfo[c]['isExpecting'] = childData['UserChildList'][c]['IsExpected'];
        user_childinfo[c]['childname'] = childData['UserChildList'][c]['ChildName'];
        user_childinfo[c]['childphoto'] = childData['UserChildList'][c]['childPhoto'];
      }
    }
    let IsTryingToConceive = 0;
    if (childData['UserMaster']) {
      IsTryingToConceive = childData['UserMaster']['IsTryingToConceive'];
    }
    return JSON.stringify({
      "user_id": mycid,
      "expecting_dob": expecting_dob,
      "user_childinfo": user_childinfo,
      "user_gender": user_gender,
      "IsTryingToConceive": IsTryingToConceive,
      "isDesk": true
    })
  }

  validateNumber(evt) {
    var theEvent = evt || window.event;

    // Handle paste
    if (theEvent.type == 'paste') {
      key = event.clipboardData.getData('text/plain');
    } else {
      // Handle key press
      var key = theEvent.keyCode || theEvent.which;
      key = String.fromCharCode(key);
    }
    // var regex = /[0-9]|\./;
    var regex = /[0-9]/;
    if (!regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  }

  closeUserlist(event) {
    if (event.target.classList.contains('followers-overlay') || event.target.classList.contains('closeButton')) {
      this.closeUserListPopup();
    }
  }

  closeUserListPopup() {
    document.getElementsByClassName('followers-overlay')[0].style.display = 'none';
    document.getElementsByClassName('followers-overlay')[0].getElementsByClassName('like-list')[0].innerHTML = '';
    document.getElementsByClassName('followers-overlay')[0].getElementsByClassName('followers-title')[0].innerHTML = '';
    document.getElementsByTagName('body')[0].style.overflow = 'visible';
  }

  getUserListHTML(sData) {
    var data = JSON.parse(sData);
    //console.log(data);
    var html = '';
    html += '<ul>';
    for (let i = 0; i < data.length; i++) {
      let user_desc = '';
      if (data[i].userDesc) {
        user_desc = data[i].userDesc;
      }
      if (data[i].userDescription) {
        user_desc = data[i].userDescription;
      }
      let user_id = '';
      if (data[i].UserId) {
        user_id = data[i].UserId;
      }
      if (data[i].userId) {
        user_id = data[i].userId;
      }
      if (data[i].likeCreaterid) {
        user_id = data[i].likeCreaterid;
      }
      let is_following = false;
      if (data[i].is_following || parseInt(data[i].is_following) == 1) {
        is_following = true;
      }
      if (data[i].isUserFollwed) {
        is_following = true;
      }
      let user_pic = '';
      if (data[i].userPhoto) {
        user_pic = data[i].userPhoto;
      }
      if (data[i].userpic) {
        user_pic = data[i].userpic;
      }
      let user_name = '';
      if (data[i].userName) {
        user_name = data[i].userName;
      }
      let user_gender = '';
      if (data[i].gender) {
        user_gender = data[i].gender;
      }
      if (data[i].userGender) {
        user_gender = data[i].userGender;
      }
      user_gender = user_gender == "1" ? "female" : (user_gender == "2" ? "male" : user_gender);
      html += '<li>';
      html += '<div class="answers-block">';
      html += '<a href=' + this.getRedirectUrl("/user-profile/" + user_id) + '>';
      html += '<div class="experts-details">';
      html += '<span class="experts-photo">';
      if (user_pic == '' || user_pic == null || user_pic == undefined) {
        if (user_gender == "female") {
          html += '<img class="imgcheck"  src="https://cdn.fcglcdn.com/brainbees/parenting/img/m/mother_profile.png" alt="Mother Profile" title="Mother Profile" /></span>';
        } else if (user_gender == "male") {
          html += '<img class="imgcheck"  src="https://cdn.fcglcdn.com/brainbees/parenting/img/m/father_profile.png" alt="Father Profile" title="Father Profile" /></span>';
        } else {
          html += '<img class="imgcheck"  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-img.png" alt="Default Profile" title="Default Profile" /></span>';
        }
      } else {
        html += `<img class="imgcheck" src="` + user_pic.replace("http://", "https://") + `" onError="this.src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-img.png';" alt="${user_name}" /></span>`;
      }
      if (!user_name || user_name == "") {
        user_name = "Community User"
      }
      html += '<span class="experts-name"><span class="exp-name M14_42">' + user_name + '</span>';
      html += '<span class="R13_9e experts-desc">' + user_desc + '</span></span>';
      html += '</div>';
      html += '</a>';
      if (user_id != global.userAry['mycid']) {
        html += '<div class="follow-block R13_9e">';
        if (is_following) {
          html += '<span id="follow_' + user_id + '" class="likelist-unfollow" data-id="' + user_id + '">Following</span>';
        } else {
          html += '<span id="follow_' + user_id + '" class="likelist-follow" data-id="' + user_id + '">Follow</span>';
        }
        html += '</div>';
      }
      html += '</div>';
      html += '</li>';
    }
    html += '</ul>';
    return html;
  }

  followUserAction(flag, uId) {
    if (global.ftk != '') {
      this.showLoader();
      var postData = {
        "user_id": uId,
        "action_status": flag,
        "action_type": 'follow_user',
        "userPic": global.userAry['userPhoto'],
        "userName": global.userAry['userName'],
        "userGender": global.userAry['Sex'],
        "childArr": global.userAry['childData']['UserChildList']
      }
      var url = global.api_ci_url + "Parenting/saveUserFollowAction";
      this.postServiceCall(url, postData).then((json) => {
        if (json['success'] == "1") {
          var ele = document.getElementById('follow_' + uId);
          if (parseInt(flag) == 1) {
            ele.classList.remove('likelist-follow');
            ele.classList.add('likelist-unfollow');
            ele.innerHTML = 'Following';
          } else {
            ele.classList.add('likelist-follow');
            ele.classList.remove('likelist-unfollow');
            ele.innerHTML = 'Follow';
          }
        }
        this.hideLoader();
      }).catch((error) => {
        console.error(error);
        this.hideLoader();
      });
    } else {
      this.showAlert("Please Login");
      window.location.href = global.loginUrl + '?URL=' + global.currentURL;
      return false;
    }
  }

  getRedirectUrl(redirectUrl) {
    if (redirectUrl.indexOf("https://parenting.firstcry.com") == 0) {
      redirectUrl = redirectUrl.replace("https://parenting.firstcry.com", "");
    } else if (redirectUrl.indexOf("http://parenting.firstcry.com") == 0) {
      redirectUrl = redirectUrl.replace("http://parenting.firstcry.com", "");
    }
    var currentUrl = global.currentURL;
    if (currentUrl.includes('from=app')) {
      if (redirectUrl.includes('?')) {
        return redirectUrl + "&from=app";
      } else {
        return redirectUrl + "?from=app";
      }
    } else {
      return redirectUrl;
    }
  }

  onKeyPressDate(event) {
    event.returnValue = false;
    if (event.preventDefault) event.preventDefault();
  }

  onFocusDate(event) {
    var val;
    if (event.target.value && event.target.value != '') {
      val = new Date(event.target.value);
      var y = val.getFullYear();
      var m = val.getMonth() + 1;
      var d = val.getDate();
      m = m > 9 ? m : "0" + m;
      d = d > 9 ? d : "0" + d;
      var finalVal = y + '-' + m + '-' + d;
      event.target.value = finalVal;
    }
    event.target.type = "date";
    event.target.readOnly = false;
    if (event.preventDefault) event.preventDefault();
    event.target.focus();
  }

  onBlurDate(event) {
    let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    event.target.type = "text";
    event.target.readOnly = true;
    if (event.target.value && event.target.value != '') {
      let date = new Date(event.target.value);
      let day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
      event.target.value = day + " " + months[date.getMonth()] + " " + date.getFullYear();
    }
  }

  isMobile() {
    if (navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      return true;
    } else {
      return false;
    }
  }

  disableCutCopyPaste(id) {
    let ele = document.getElementById(id);
    if (ele) {
      ele.onpaste = e => {
        e.preventDefault();
        return false;
      };
      ele.oncopy = e => {
        e.preventDefault();
        return false;
      };
      ele.oncut = e => {
        e.preventDefault();
        return false;
      };
    }
  }

  scrollCenterKeySlider() {
    let elem = document.querySelector("#keySlider ul li.active");
    var activeWidth = elem.offsetWidth / 2;
    var pos = elem.offsetLeft + activeWidth;
    var elpos = document.querySelector("#keySlider").scrollLeft;
    var elW = document.querySelector("#keySlider").offsetWidth;
    var scrolllft = pos + elpos - elW / 2;
    document.querySelector("#keySlider").scrollLeft = scrolllft - elpos;
  }

  isInViewport(el) {
    // //console.log("element===============>",el);
    const scroll = window.scrollY || window.pageYOffset
    const boundsTop = el.getBoundingClientRect().top + scroll
    const viewport = {
      top: scroll,
      bottom: scroll + window.innerHeight,
    }
    const bounds = {
      top: boundsTop,
      bottom: boundsTop + el.clientHeight,
    }
    return (bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom)
      || (bounds.top <= viewport.bottom && bounds.top >= viewport.top);
  }

  loadChatJsFile(eleRef) {
    new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = "https://cdn.cdnparenting.com/brainbees/community/preact/public/chart.min.js";
      script.addEventListener('load', function () { resolve(); });
      script.addEventListener('error', function (e) { reject(e); });
      document.body.appendChild(script);
    }).then(function () {
      eleRef.isChatJsLoaded = true;
      eleRef.getStatsData();
      //console.log("loaded chart.js");
    }).catch(function () {
      //console.log("error loading chart.js");
    })
  }

  loadHtml2CanvasFile(eleRef) {
    new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = "https://cdn.cdnparenting.com/brainbees/community/preact/public/html2canvas.js";
      script.addEventListener('load', function () { resolve(); });
      script.addEventListener('error', function (e) { reject(e); });
      document.body.appendChild(script);
    }).then(function () {
      eleRef.convertHtml2Canvas();
      //console.log("loaded html2canvas.js");
    }).catch(function () {
      //console.log("error loading html2canvas.js");
    })
  }

  loadAliplayerFiles() {
    // load css file
    var tag1 = document.createElement('link');
    tag1.href = "https://g.alicdn.com/de/prismplayer/2.8.7/skins/default/aliplayer-min.css";
    tag1.rel = "stylesheet";
    document.body.appendChild(tag1);
    return new Promise(function (resolve, reject) {
      // load js file
      var script = document.createElement('script');
      script.src = "https://g.alicdn.com/de/prismplayer/2.8.7/aliplayer-min.js";
      script.addEventListener('load', function () {
        //console.log("resolve js");
        resolve();
      });
      script.addEventListener('error', function (e) {
        //console.log("reject js");
        reject(e);
      });
      document.body.appendChild(script);
    })
  }

  loadJcropFiles() {
    // load css file
    var tag1 = document.createElement('link');
    tag1.href = "https://cdn.cdnparenting.com/brainbees/community/preact/public/jquery-jcrop/jquery-jcrop.css";
    tag1.rel = "stylesheet";
    document.body.appendChild(tag1);
    return new Promise(function (resolve, reject) {
      // load js file
      var script = document.createElement('script');
      script.src = "https://cdn.cdnparenting.com/brainbees/community/preact/public/jquery-jcrop/jquery-jcrop.js";
      script.addEventListener('load', function () {
        //console.log("resolve js");
        resolve();
      });
      script.addEventListener('error', function (e) {
        //console.log("reject js");
        reject(e);
      });
      document.body.appendChild(script);
    })
  }

  initializeVideoPlayer(_this, player) {
    if (_this.state.fileLoadStatus == 'done') {
      var videoAry = document.getElementsByClassName('memory_video');
      for (let v = 0; v < videoAry.length; v++) {
        var id = videoAry[v].getAttribute('data-id');
        var url = videoAry[v].getAttribute('data-url');
        var img = videoAry[v].getAttribute('data-img');
        if (!player.hasOwnProperty(id)) {
          player[id] = new Aliplayer({
            id: id,
            loop: true,
            autoplay: false,
            skinLayout: [
              { name: "bigPlayButton", align: "blabs", x: 30, y: 80 },
              { name: "H5Loading", align: "cc" },
              { name: "errorDisplay", align: "tlabs", x: 0, y: 0 },
              // { name: "snapshot", align: "trabs", x: 10, y: "50%" },
              { name: "infoDisplay", align: "cc" },
              {
                name: "controlBar", align: "blabs", x: 0, y: 0,
                children: [
                  { name: "progress", align: "blabs", x: 0, y: 44 },
                  { name: "playButton", align: "tl", x: 15, y: 12 },
                  { name: "timeDisplay", align: "tl", x: 10, y: 7 },
                  { name: "fullScreenButton", align: "tr", x: 10, y: 10 },
                  // { name: "snapshot", align: "tr", x: 10, y: 10 },
                  { name: "volume", align: "tr", x: 10, y: 10 },
                  { name: "streamButton", align: "tr", x: 0, y: 10 },
                  { name: "speedButton", align: "tr", x: 0, y: 10 },
                  { name: "captionButton", align: "tr", x: 0, y: 10 },
                  { name: "trackButton", align: "tr", x: 0, y: 10 },
                ]
              }
            ],
            // isLive:true,
            userH5Prism: true,
            playsinline: true,
            source: url,
            cover: img,
          });

          player[id].on('ready', function (e) {
            //console.log("ready " + id);
            if (document.getElementById(id)) {
              let vHeight = document.getElementById(id).getElementsByTagName('video')[0].offsetHeight;
              document.getElementById(id).style.height = vHeight + "px";
            }
          });

          player[id].on('play', function (e) {
            //console.log("play " + id);
            _this.playVideoId = id;
            // var playerAry = document.getElementsByClassName('memory_video');
            // for (var i = 0; i < playerAry.length; i++) {
            //   if (playerAry[i].getAttribute('data-id') != id) {
            //     player[playerAry[i].getAttribute('data-id')].pause();
            //   }
            // }
          });

          player[id].on('pause', function (e) {
            //console.log("pause " + id);
            if (_this.playVideoId == id) {
              _this.playVideoId = "";
            }
          });
        }
      }
      //console.log("player==========", player);
    }
    return player;
  }

  do_load_files(self, player) {
    var _this = this;
    _this.loadAliplayerFiles().then(function () {
      self.setState({ 'fileLoadStatus': 'done' }, () => { player = _this.initializeVideoPlayer(self, player); });
    }).catch(function () {
      self.setState({ 'fileLoadStatus': 'error' });
    })
  }

  destroyPlayerObj(player) {
    let keyAry = Object.keys(player);
    for (let i = 0; i < keyAry.length; i++) {
      player[keyAry[i]].destroy();
      delete player[keyAry[i]];
    }
    player = {};
    //console.log("after:::", player);
    return player;
  }

  getChildAge(dob) {
    var now = new Date();
    var yearNow = now.getYear();
    var monthNow = now.getMonth();
    var dateNow = now.getDate();

    var dob = new Date(dob.replace(/-/g,'/'));
    var yearDob = dob.getYear();
    var monthDob = dob.getMonth();
    var dateDob = dob.getDate();

    var age = {};

    var yearAge = yearNow - yearDob;

    if (monthNow >= monthDob) {
      var monthAge = monthNow - monthDob;
    } else {
      yearAge--;
      var monthAge = 12 + monthNow - monthDob;
    }

    if (dateNow >= dateDob) {
      var dateAge = dateNow - dateDob;
    } else {
      monthAge--;
      var dateAge = 31 + dateNow - dateDob;
      if (monthAge < 0) {
        monthAge = 11;
        yearAge--;
      }
    }

    age = {
      years: yearAge,
      months: monthAge,
      days: dateAge
    };

    var ageString = '';
    if (yearAge > 0) {
      if (yearAge > 1) {
        ageString = yearAge + ' yrs old';
      } else {
        ageString = yearAge + ' yr old';
      }
    } else if (yearAge <= 0 && monthAge > 0) {
      if (monthAge > 1) {
        ageString = monthAge + ' months old';
      } else {
        ageString = monthAge + ' month old';
      }
    } else if (yearAge <= 0 && monthAge <= 0 && dateAge > 0) {
      if (dateAge > 1) {
        ageString = dateAge + ' days old';
      } else {
        ageString = dateAge + ' day old';
      }
    }
    return ageString;
  }

  getSelectedChild(childData) {
    var childId = 0;
    if (childData && childData.UserChildList && childData.UserChildList.length > 0) {
      if (childData.UserChildList.length == 1 && childData.UserChildList[0].IsExpected) {
        childId = 0;
      } else {
        if (!childData.UserChildList[0].IsExpected) {
          childId = childData.UserChildList[0].ChildId;
        } else {
          childId = childData.UserChildList[1].ChildId;
        }
      }
    }
    return childId;
  }

  changeImgUrl(imgurl){
    var new_url = imgurl.replace("https://frontendmultiprofile.s3.amazonaws.com", "https://cdn.cdnparenting.com/fcprofile");
    var new_url1 = new_url.replace("https://bbcdnlivemumbai.s3.ap-south-1.amazonaws.com", "https://cdn.cdnparenting.com");
    return new_url1;
  }

  gardianProfileChk() {
    if (global.ftk && ((global.userAry['Sex'] == "" || global.userAry['Sex'] == null) && global.userAry['childData']['UserChildList'] && global.userAry['childData']['UserChildList'].length >= 1)) {
      this.showAlert("Please Complete Your Profile");
      window.location.href = '/my-account?URL=' + global.currentURL;
      return false;
    } else {
      return false;
    }
  }

  forceDownload(fileURL, eleRef) {
    var url = fileURL;
    var fileName = fileURL.split('/').pop().replace("jpeg", "webp").replace("jpg", "webp");
    // var fileName = fileURL.split('/').pop();
    // link.innerText = "Working...";
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function () {
      var urlCreator = window.URL || window.webkitURL;
      var imageUrl = urlCreator.createObjectURL(this.response);
      var tag = document.createElement('a');
      tag.href = imageUrl;
      tag.download = fileName;
      document.body.appendChild(tag);
      tag.click();
      document.body.removeChild(tag);
      // link.innerText="Download Image";
    }
    xhr.send();
  }

}
export default Service;
